import {uniq} from 'lodash';

import {
  InviaType,
  isRoomAttributeBalconyTerraceType,
  isRoomViewType,
} from '@/utils/inviaType';

const extractInviaMainType = (inviaType: string): string => {
  return new InviaType(inviaType).mainType;
};

// @todo this should not be needed
//
// a potential idea would be that we support main and subtypes and also render both in the UI
// [] IT13-SEVI
//    [] IT13-SEVI#SEVI
//    [] IT13-SEVI#PART
//
// when main type is filtered all checkboxes should be checked
// when a subtype is filtered the main type checkbox should be indeterminate & the subtype checkbox should be checked
export const collapseRoomAttributesFilterValue = (
  roomAttributesFilterValue: Array<string>
): Array<string> => {
  return uniq(
    roomAttributesFilterValue.map((roomAttribute) => {
      // We only want to show one "Seaview" option,
      // so we reduce more specific room views parameters down to just the main type.
      // The assumption being that people don't want to search for just "Partial Seaview" only for example.
      // The same applies to "Balcony" / "Terrace", where we only want one option aswell.
      if (
        isRoomViewType(roomAttribute) ||
        isRoomAttributeBalconyTerraceType(roomAttribute)
      ) {
        return extractInviaMainType(roomAttribute);
      }
      return roomAttribute;
    })
  );
};
